module.exports = __webpack_public_path__ + "img/watage_res_13.91cddbde.gif";